$(document).ready(function () {

    $(".faq-item .question span, .faq-item .question button").click(function(e) {
        e.preventDefault();
        $(this)
            .parent()
            .parent()
            .toggleClass("open");
    });

    if (document.querySelector('.header-main h1.title')) {
        document.querySelector('.header-main h1.title').classList.add("animated");
    }
    if (document.querySelector('.header-main .subtitle')) {
        document.querySelector('.header-main .subtitle').classList.add("animated");
    }
    if (document.querySelector('.header-main .btn')) {
        document.querySelector('.header-main .btn').classList.add("animated");
    }
    if (document.querySelector('header .header-image')) {
        document.querySelector('header .header-image').classList.add("animated");
    }

    function blocksVisibility() {

        function Check() {

        }

        Check.prototype = {
            constructor: Check,
            isElementInView: function (element, fullyInView) {
                var pageTop = $(window).scrollTop();
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(element).offset() && $(element).offset().top;
                var elementBottom = elementTop + $(element).height();

                if (fullyInView === true) {
                    return ((pageTop < elementTop) && (pageBottom > elementBottom));
                } else {
                    return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
                }
            }
        };

        var Check = new Check();

        function doAnimate(elem) {

            var isElementInView = Check.isElementInView(elem, false);
            if (isElementInView) {
                if ( !elem.hasClass('animated') ) {
                    elem.addClass('animated');
                }
            }
        }

        const animateBloks = [$('.characteristics'),$('.main-characteristics'), $('.terms').eq(0),$('.filling'), $('.terms').eq(1), $('.button-wrapper')];
        animateBloks.forEach(function(block) {
            doAnimate(block);
        });
    }
    window.addEventListener('scroll', blocksVisibility, {passive: true} );
    blocksVisibility();


    $('.scrollToForm').on("click keypress",  function(e){
        if (e.type === 'keypress' && e.which !== 13) {
            return;
        }

        let $form = $('.vue-form');
       if ($form.length) {
            $('html, body').stop().animate({
                scrollTop: $form.offset().top
            }, 1000, function() {
                let $firstInput = $form.find('input:not([type="hidden"]), select, textarea, button').first();
                
                if ($firstInput.length) {
                    $firstInput.focus();
                } else {
                    $form.attr('tabindex', '-1').focus();
                }
            });
        }

    });

});
